import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RouteComponentProps } from 'react-router';
import { IStore } from 'reducers/index';
import { ErrorDialog } from 'components/error-dialog';
import API from 'constants/api';
import { PageHeader } from 'components/page-header';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { ICblDetail } from 'reducers/cbl/models';
import { GetCBLDetails, resetCBLDetails } from 'actions/cbl';
import { withRouter } from 'react-router-dom';
import InPageDialog from '../../../../components/page-dialog';
import { navLinksCBL, clrCols, equipmentColsForCBL, bookingsCols, fcrCols, equipmentTransportShipmentsCols, voyagesCols, customerInvoiceCols } from 'constants/tableConstants';
import { DetailsTopBar } from './DetailsTopBar';
import { HeaderWrapper } from 'components/cost-revenue/HeaderWrapper';
import CblDetails from './CblDetails';
import * as ValidationMessages from 'constants/validationMessages';
import { HistoryLog } from 'modules/history/HistoryLog';
import { Partners } from 'modules/partners/Partners';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { generateDistributionData, calculateTotalOfField, findAllinArr } from 'views/job-costing/utils/CostAndRevenueHelpers';
import { clearFormat, formatValueIfNullOrUndefined, formatDate, isFeatureEnabled } from 'utilities/util';
import { CostAndRevenue } from 'modules/cost-revenue/component/CostAndRevenue';
import { CostAndRevenueNew } from 'modules/cost-revenue-new/component/CostAndRevenueNew';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { localCurrency } from 'constants/customs';
import { fetchCostAndRevenue, fetchCostData, fetchRevenueData } from 'actions/costRevenue';
import { IResponse, IResponseCostorRevenue } from 'reducers/bookings/models';
import { targetFunctionality } from 'constants/targetFunctionality';
import { ATHENA } from 'constants/messages';
import { fetchNftpBillable } from 'actions/exportJob';
import { isNftpRoeEnabled, calculateActualTotal } from 'utilities/nftp';
interface IParams {
    cblId: string;
}
interface IMapDispatchToProps {
    GetCBLDetails: (CblId: number) => Promise<void>;
    resetCBLDetails: () => void;
    fetchCostAndRevenue: (type: number, valueId: any[], targetType: string) => Promise<void>;
    fetchRevenueData: (id: number, page?: number, pageSize?: number) => Promise<void>;
    fetchCostData: (id: number, page?: number, pageSize?: number, column?: string, order?: number) => Promise<void>;
    fetchNftpBillable: (jobId: number) => Promise<void>;
}
interface IMapStateToProps {
    details: ICblDetail;
    isLoading: boolean;
    isFetchDataError: boolean;
    detailsPendingError: string;
    featureToggles: IFeatureToggleModel[];
    costAndrevenueresponse: IResponse;
    costResponse: IResponseCostorRevenue;
    revenueResponse: IResponseCostorRevenue;
    isNftpBillable: boolean | undefined;
    isNftpBillableLoading: boolean; 
}
interface ICBLCharges extends RouteComponentProps<IParams>, IMapDispatchToProps, IMapStateToProps { }
interface IState {
    activeTab: number,
    disableTab: boolean,
    hasError: boolean,
    totalRevenue: string,
    totalCost: string,
    showDialog: boolean,
    pendingError: string,
    status: string[],
    isActionHidden: boolean,
    isNftpRoeEnabled?: boolean,
    isNftpRoeEnabledLoading?: boolean,
    actualRevenue?: string,
    actualCost?: string
}
export class _ChargesCblsDetails extends React.Component<ICBLCharges, IState> {
    constructor(props: ICBLCharges) {
        super(props);
        this.state = this.initialState()
    }
    public componentDidMount() {
        const isCostAndRevenueFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.CBL_COSTANDREVENUE, this.props.featureToggles);
        this.props.GetCBLDetails(Number(this.props.match.params.cblId));
        if (isCostAndRevenueFeatureEnabled) {
            this.props.fetchRevenueData(Number(this.props.match.params.cblId), 1, 10)
            this.props.fetchCostData(Number(this.props.match.params.cblId), 1, 10, 'id', 0)
        } else {
            this.props.fetchCostAndRevenue(3, [Number(this.props.match.params.cblId)], 'origin')
        }
    }
    public componentWillUnmount() {
        this.initialState()
        this.props.resetCBLDetails()
    }
    public initialState = (): IState => {
        return {
            activeTab: 0,
            disableTab: false,
            showDialog: false,
            totalRevenue: '0',
            totalCost: '0',
            pendingError: '',
            status: [],
            hasError: false,
            isActionHidden: false,
            isNftpRoeEnabled: false,
            isNftpRoeEnabledLoading: true,
            actualRevenue: '0',
            actualCost: '0'
        }
    }
    public async componentDidUpdate(props: any) {
        if (this.props.isFetchDataError !== this.props.isFetchDataError &&
            this.props.isFetchDataError === true && this.props.detailsPendingError) {
            let checkText: string | string[] = this.props.detailsPendingError
            if ((Array.isArray(this.props.detailsPendingError) &&
                this.props.detailsPendingError.length === 0) ||
                this.props.detailsPendingError === '') {
                checkText = 'Server Error. Try again later.'
            }
            this.setState({ showDialog: true, pendingError: checkText.toString() })
        }
        if (this.props.details !== props.details) {
            const firstJob = this.props.details.documents[0];
            if (firstJob && isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_SALESORDER_REQ_EXPORT, this.props.featureToggles)) {
                await this.props.fetchNftpBillable(Number(firstJob.exportJobId));
            }
            this.setState({ isNftpRoeEnabled: isNftpRoeEnabled(this.props.isNftpBillable ?? false, this.props.featureToggles) });
            this.setState({ isNftpRoeEnabledLoading: false});
            this.getActualTotal();
            const handleError = (error: string[]): boolean => {
                const errList: string[] = []
                this.props.details.documents.forEach((child: any) => {
                    if (child.rateErrorMessage && child.rateErrorMessage !== '-') {
                        errList.push(child.rateErrorMessage)
                    }
                })
                if (error && errList && errList.length > 0) {
                    this.setState({ showDialog: true, pendingError: errList.toString().replace(/\|/g, '\n') })
                    return true
                }
                return false
            }

            const status: string[] = findAllinArr(this.props.details.documents, 'finOpsStatus')
            const hasError: boolean = this.props.details && this.props.details.documents ? handleError(this.props.details.documents) : false;
            this.setState({
                status,
                hasError
            })
        }
    }
    public getActualTotal = () => {
        const isCostAndRevenueFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.CBL_COSTANDREVENUE, this.props.featureToggles);
        let actualRevenue = '0';
        let actualCost = '0';

        if (isCostAndRevenueFeatureEnabled) {
            const revRateDetailsList = this.props.revenueResponse.data || [];
            revRateDetailsList.forEach((item: any) => {
                item.itemCategory = CostColumnsData.TYPES.REVENUE;
            });
            const costRateDetailsList = this.props.costResponse.data || [];
            costRateDetailsList.forEach((item: any) => {
                item.itemCategory = CostColumnsData.TYPES.COST;
            });
            actualRevenue = calculateActualTotal(revRateDetailsList, CostColumnsData.TYPES.REVENUE);
            actualCost = calculateActualTotal(costRateDetailsList, CostColumnsData.TYPES.COST);
        }
        else {
            const rateDetailsList = this.props.costAndrevenueresponse.result[0]?.essoRateDetailsModels || [];
            actualRevenue = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.REVENUE);
            actualCost = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.COST);
        }
        this.setState({ actualRevenue, actualCost }) ;
    };
    public getCblDocData = (): any[] => {
        return this.props.details.documents.map((el: any) => ({
            ...el,
            deliveryTimeEstimated: el.estimatedDeliveryTime,
            destinationService: el.serviceAtDestination,
            originService: el.serviceAtOrigin,
            insertDate: el.createDate,
            updateDate: el.lastUpdateDate
        }))
    }

    public render() {
        const isRevButtonHidden = this.props.details.documents.some(item => item.businessSubCategory === 'RFREV')
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isCostAndRevenueFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.CBL_COSTANDREVENUE, this.props.featureToggles);
        const isBKSDocument = this.props.details.documents.filter((val: any) => val.originalDocumentNumber && val.originalDocumentNumber.startsWith('EEDB')).length > 0;
        const enableBlockedType = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);

        let exportJobLinks;
        if (this.props.details.documents) {
            const filteredDocs = this.props.details.documents.filter(item => item.finNumber);
            exportJobLinks = filteredDocs.length > 0 ? filteredDocs.map((item, index) => <div className="mB10" key={index} ><a onClick={() => { this.props.history.push(`/job-costing/exportjobs/${item.exportJobId}`) }} >{item.finNumber}</a></div>) : '-';
        }
        else {
            exportJobLinks = '-';
        }
        return (
            <React.Fragment>
                <ErrorDialog endpoint={API.CBL.CblDetails} />
                {this.props.details && this.props.details.number && <PageHeader
                    id="Cbl-header"
                    displayConfirm={this.state.disableTab}
                    confirmMessage={this.state.disableTab ? ValidationMessages.CostAndRevenue.Alert_Page_Exit : ''}
                    backButton={true}>CBL Number: {this.props.details.number}</PageHeader>}
                {this.state.showDialog && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.pendingError}
                    closeMethod={() => this.setState({ showDialog: false })} /></div>}
                <HeaderWrapper
                    firstValue={this.props.details.carrierCode}
                    firstValueLabel={'Carrier SCAC'}
                    secondValue={this.props.details.documents && this.props.details.opsStatus}
                    secondValueLabel={'CBL Status'}
                    thirdValue={''}
                    thirdValueLabel={''}
                    forthValue={formatDate(this.props.details.updateDate)}
                    forthValueLabel={'Last Updated Time'}
                    statusColor={this.state.hasError ? 'red' : ''}
                    target={2}
                    totals={{
                        firstRow: { label: 'Total Revenue', value: this.state.totalRevenue, actualValue: this.state.actualRevenue },
                        secondRow: { label: 'Total Cost', value: this.state.totalCost, actualValue: this.state.actualCost },
                        lastRow: { label: 'Profitability' },
                        isNftpRoeEnabled: this.state.isNftpRoeEnabled
                    }}
                />
                <DetailsTopBar
                    voyage={this.props.details.voyages && this.props.details.voyages.length > 0 ? this.props.details.voyages[0].voyageNumber : ''}
                    vessel={this.props.details.voyages && this.props.details.voyages.length > 0 ? this.props.details.voyages[0].vesselCode : ''}
                    eta={this.props.details.documents && this.props.details.voyages && this.props.details.voyages.length > 0 ? this.props.details.voyages[0].eta : ''}
                    etd={this.props.details.documents && this.props.details.voyages && this.props.details.voyages.length > 0 ? this.props.details.voyages[0].etd : ''}
                    placeOfDelivery={this.props.details.placeOfDeliveryCode}
                    placeOfReceipt={this.props.details.documents && this.props.details.documents.length > 0 ? this.props.details.documents[0].placeOfReceiptCode : ''}
                    portOfDischarge={this.props.details.finalPortOfDischargeCode}
                    portOfLoading={this.props.details.originalPortOfLoadingCode}
                    serviceContractNumber={this.props.details.transportContractNumber}
                    cblReferenceNumber={this.props.details.carrierBookingReference}
                    isActionHidden={true}
                />
                <div className="padding-left-large padding-right-large">
                    {!this.props.isNftpBillableLoading && !this.state.isNftpRoeEnabledLoading &&this.props.details && this.props.details.documents && this.props.details.documents.length > 0 &&
                        <TabComponent name="Cbls" navLinks={navLinksCBL}
                            isDisabled={this.state.disableTab}
                            callbackFc={(e: number) => this.setState({ activeTab: e })}>
                            {this.props.details.cblId && isCostAndRevenueFeatureEnabled ? <CostAndRevenueNew
                                targetType="origin"
                                showInvoices={false}
                                toggleTabs={(b: boolean) => this.setState({ disableTab: b })}
                                fStatus={this.state.status}
                                targetId={targetFunctionality.CBL}
                                partyData={{ country: this.props.details.documents[0] && this.props.details.documents[0].issuerCountryCode, company: this.props.details.documents[0].companyCode, purchase: null }}
                                distributionData={generateDistributionData(this.props.details)}
                                readOnly={false}
                                isRevButtonHidden={isRevButtonHidden}
                                revenueResponseData={this.props.revenueResponse}
                                costResponseData={this.props.costResponse}
                                docId={this.props.details.documents[0].exportJobId}
                                costAndRevenueId={this.props.details.cblId}
                                getCurrentPageMode={(mode) => this.setState({ isActionHidden: (mode === 'edit' || mode === 'add') ? true : false })}
                                eventCallback={() => this.setState({ showDialog: false, pendingError: '' })}
                                isSourceAthena={this.props.details.documents[0]?.pricingSource === 2 || this.props.details.documents[0]?.pricingSource === ATHENA}
                                isNftpBillable={this.props.isNftpBillable}
                                isNftpRoeEnabled={this.state.isNftpRoeEnabled}
                                outputCostRev={(cost: any[], revenue: any[]) => {
                                    this.setState({ totalCost: clearFormat(calculateTotalOfField(cost, localCurrency.totalLocalCurrency)) });
                                    this.setState({ totalRevenue: clearFormat(calculateTotalOfField(revenue, localCurrency.totalLocalCurrency)) })
                                }
                                } /> :
                                <CostAndRevenue
                                    targetType="origin"
                                    showInvoices={false}
                                    toggleTabs={(b: boolean) => this.setState({ disableTab: b })}
                                    fStatus={this.state.status}
                                    targetId={targetFunctionality.CBL}
                                    partyData={{ country: this.props.details.documents[0] && this.props.details.documents[0].issuerCountryCode, company: this.props.details.documents[0].companyCode, purchase: null }}
                                    distributionData={generateDistributionData(this.props.details)}
                                    readOnly={true}
                                    splitCols={CostColumnsData.getCostCBLSubCols(isExtraDocumentFeatureEnabled)}
                                    docId={this.props.details.documents[0].exportJobId}
                                    costAndRevenueId={this.props.details.cblId}
                                    costAndrevenueresponse={this.props.costAndrevenueresponse}
                                    eventCallback={() => this.setState({ showDialog: false, pendingError: '' })}
                                    getCurrentPageMode={(mode) => this.setState({ isActionHidden: (mode === 'edit' || mode === 'add') ? true : false })}
                                    isNftpBillable={this.props.isNftpBillable}
                                    isNftpRoeEnabled={this.state.isNftpRoeEnabled}
                                    outputCostRev={(cost: any[], revenue: any[]) => {
                                        this.setState({ totalCost: clearFormat(calculateTotalOfField(cost, localCurrency.totalLocalCurrency)) });
                                        this.setState({ totalRevenue: clearFormat(calculateTotalOfField(revenue, localCurrency.totalLocalCurrency)) })
                                    }
                                    } />
                            }
                            <CblDetails
                                link={(url: string) => {
                                    this.props.history.push(url)
                                }}
                                organisation={[
                                    { label: 'Company Code', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].companyCode) : '-' },
                                    { label: 'Plant', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].plant) : '-' },
                                    { label: 'Sales Area', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].salesArea) : '-' },
                                    { label: 'Purchase Organisation', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].purchaseOrganisation) : '-' },
                                    { label: 'Origin Office', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].originOffice) : '-' },
                                    { label: 'Destination Office', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].destinationOffice) : '-' },
                                ]}
                                locations={[
                                    { label: 'Place of receipt code', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].placeOfReceiptCode) : '-' },
                                    { label: 'Port of loading code', value: formatValueIfNullOrUndefined(this.props.details.originalPortOfLoadingCode) },
                                    { label: 'Port of discharge code', value: formatValueIfNullOrUndefined(this.props.details.finalPortOfDischargeCode) },
                                    { label: 'Place of delivery code', value: formatValueIfNullOrUndefined(this.props.details.placeOfDeliveryCode) },
                                    { label: 'Place of receipt name', value: this.props.details.documents && this.props.details.documents.length > 0 ? formatValueIfNullOrUndefined(this.props.details.documents[0].placeOfReceiptName) : '-' },
                                    { label: 'Port of loading name', value: formatValueIfNullOrUndefined(this.props.details.originalPortOfLoadingName) },
                                    { label: 'Port of discharge name', value: formatValueIfNullOrUndefined(this.props.details.finalPortOfDischargeName) },
                                    { label: 'Place of delivery name', value: formatValueIfNullOrUndefined(this.props.details.placeOfDeliveryName) },
                                ]}
                                cargo={[ // sum from equipments
                                    { label: 'Quantity', value: String(this.props.details.quantity) },
                                    { label: 'Weight', value: String(clearFormat(this.props.details.weight, 3)) },
                                    { label: 'Volume', value: String(clearFormat(this.props.details.volume, 3)) },
                                    { label: 'Total Package', value: String(this.props.details.packages) }
                                ]}
                                jobIdDetails={[
                                    { label: 'Export', value: exportJobLinks },
                                    { label: 'Import', value: formatValueIfNullOrUndefined('') }
                                ]}
                                equipments={{
                                    data: this.props.details.equipments,
                                    cols: equipmentColsForCBL,
                                    name: 'cbl-details-equipments'
                                }}
                                bookings={{
                                    data: this.props.details.bookings,
                                    cols: bookingsCols,
                                    name: 'cbl-details-bookings'
                                }}
                                fcr={{
                                    data: this.getCblDocData(),
                                    cols: fcrCols(isExtraDocumentFeatureEnabled, !isBKSDocument, isHblConsumptionEnabled),
                                    name: 'cbl-details-fcr'
                                }}
                                clr={{
                                    data: this.props.details.clrs,
                                    cols: clrCols,
                                    name: 'cbl-details-clr'
                                }}
                                equipmentTransportShipments={{
                                    data: this.props.details.equipmentTransportShipments,
                                    cols: equipmentTransportShipmentsCols,
                                    name: 'cbl-details-equipmentTransportShipments'
                                }}
                                voyages={{
                                    data: this.props.details.voyages,
                                    cols: voyagesCols,
                                    name: 'cbl-details-voyages'
                                }}

                                customerInvoice={{ data: this.props.details.billingDocuments, cols: customerInvoiceCols, name: 'cbls-customerInvoice-' }}
                                isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                            />
                            {this.state.activeTab === 3 && <Partners isVisible={this.state.activeTab === 3} target={3} targetId={this.props.details.cblId} />}
                            {this.state.activeTab === 4 &&
                                <HistoryLog
                                    shipmentId={this.props.details.cblId.toString()}
                                    shipmentType={3}
                                    enableBlockedType={enableBlockedType}
                                />
                            }
                        </TabComponent>}
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    details: state.cbl.details,
    isLoading: state.cbl.isFetchDataLoading,
    isFetchDataError: state.cbl.isFetchDataError,
    detailsPendingError: state.cbl.detailsPendingError,
    featureToggles: state.featureToggle.featureToggles,
    costAndrevenueresponse: state.costRevenue.response,
    revenueResponse: state.costRevenue.revenueResponse,
    costResponse: state.costRevenue.costResponse,
    isNftpBillable: state.exportJob.nftpBillableResponse?.isNftpBillable,
    isNftpBillableLoading: state.exportJob.isNftpBillableLoading
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    GetCBLDetails: (CblId: number) => dispatch(GetCBLDetails(CblId)),
    resetCBLDetails: () => dispatch(resetCBLDetails()),
    fetchCostAndRevenue: (type: number, valueId: any, targetType: string) => dispatch(fetchCostAndRevenue(type, valueId, targetType)),
    fetchRevenueData: (id: number, page?: number, pageSize?: number) => dispatch(fetchRevenueData(id, page, pageSize)),
    fetchCostData: (id: number, page?: number, pageSize?: number) => dispatch(fetchCostData(id, page, pageSize)),
    fetchNftpBillable: (jobId: number) => dispatch(fetchNftpBillable(jobId))
});

export const _Cbls = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ChargesCblsDetails);
export const Cbls = withRouter(_Cbls);